import { Controller } from "@hotwired/stimulus"

// Handles "Выгрузить в хранилище" / "Обновить файл в хранилище" button
// on the ProcessingResult show page (control-list tab).
// After a successful push the page is reloaded via Turbo to refresh state.
export default class extends Controller {
  static targets = ["button", "info", "urlLink"]
  static values = { pushUrl: String, hasFile: Boolean }

  async push(event) {
    event.preventDefault()

    const button = this.buttonTarget
    const originalText = button.innerHTML
    button.disabled = true
    button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Выгрузка...'

    try {
      const response = await fetch(this.pushUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "application/json"
        }
      })

      const data = await response.json()
      if (!response.ok || !data.success) {
        throw new Error(data.error || "Ошибка выгрузки")
      }

      if (window.Toast) {
        window.Toast.fire({ icon: "success", title: data.message })
      }

      // Reload the page via Turbo (preserves the current tab hash)
      setTimeout(() => {
        if (typeof Turbo !== "undefined") {
          Turbo.visit(window.location.href)
        } else {
          window.location.reload()
        }
      }, 500)
    } catch (error) {
      alert(`Ошибка: ${error.message}`)
      button.innerHTML = originalText
      button.disabled = false
    }
  }
}
